<template>
    <div class="row">
        <div class="col-12 col-md-12 note-head">
            <div class="note-title">
                <h4>{{ note.name }}</h4>
            </div>
            <div class="note-btn d-flex align-items-center" v-if="!note.isHideAddBtn">
                <button @click="onOpenModal(note, index)" type="button" class="btn btn-outline-primary btn-sm btn-block">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
        </div>
        <div class="col-21">
            <hr class="mt-0">
        </div>
        <div class="col-12 col-md-12 note-body">
            <div class="card">
                <div class="card-body">
                    <div class="medicine" v-for="(item, noteIndex) in note.selectedNotes" :key="noteIndex">
                        <div class="row">
                            <div class="col-8 medicine-name">
                                <span class="sr-no">{{ noteIndex + 1 }}. </span>
                                <span v-if="currentIndex !== noteIndex" @click="setEdit(item, noteIndex)" class="name">{{ item }}</span>
                                <span v-show="currentIndex === noteIndex">
                                    <input 
                                        v-model.trim="editValue" type="text" 
                                        @blur="onUpdate(item, noteIndex)"
                                        @keyup.enter="onUpdate(item, noteIndex)"
                                        class="note-input form-control"
                                        ref="input"
                                    >
                                </span>
                            </div>
                            <div class="col-3 row" v-if="markedPosition[noteIndex]">
                                <div @click="onMarkPosition(noteIndex, 'first')" class="col-6 first-col">
                                    <span v-if="markedPosition[noteIndex].first"><i class="fas fa-check"></i></span>
                                </div>
                                <div @click="onMarkPosition(noteIndex, 'second')" class="col-6 second-col">
                                    <span v-if="markedPosition[noteIndex].second"><i class="fas fa-check"></i></span>
                                </div>
                                <div @click="onMarkPosition(noteIndex, 'third')" class="col-6 third-col">
                                    <span v-if="markedPosition[noteIndex].third"><i class="fas fa-check"></i></span>
                                </div>
                                <div @click="onMarkPosition(noteIndex, 'fourth')" class="col-6 fourth-col">
                                    <span v-if="markedPosition[noteIndex].fourth"><i class="fas fa-check"></i></span>
                                </div>
                            </div>
                            <div class="col-1 action" @click="onRemoveNote(item, noteIndex)"  v-if="!note.isHideAddBtn">
                                <i class="far fa-times-circle close"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-12 note-footer pb-2" v-if="from === 'group-template'">
            <SubmitCancelBtn
                class="text-right"
                @onSubmit="onSaveTemplate"
                :loading="loading"
                :isHideCancelBtn="true"
                :disabled="note.selectedNotes.length === 0"
            />
        </div>
        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue"
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import { convertToTitleCase } from '@/services/utils/global';
import Loader from '@/components/atom/LoaderComponent'

const props = defineProps({
    note: Object,
    index: {
        type: Number,
        default: -1,
    },
    from: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['openModal'])
const currentIndex = ref(-1);
const editValue = ref(null);
const input = ref(null)
const loading = ref(false);
const markedPosition = ref([]);
const isInitialMount = ref(true);

const onOpenModal = (note, index = -1) => {
    if(note.value){
        note.name = convertToTitleCase(note.value);
    }
    emit('openModal', {note, index})
}

const onRemoveNote = (noteName, selectedIndex) => {
    props.note.selectedNotes.splice(selectedIndex, 1);
    onInsertOrUpdateCcNote('delete', selectedIndex);

    const index = props.note.newNotesByDoctor.indexOf(noteName);
    if(index < 0) return;

    props.note.newNotesByDoctor.splice(index);
}

const setEdit = (note, index) => {
    if(props.note.isHideAddBtn) return;

    currentIndex.value = index;
    editValue.value = note;

    if (input.value && input.value[index]) {
        input.value[index].focus();
    }
}

const onMarkPosition = (index, position) => {
    const item = markedPosition.value[index];
    if( ! item) return;

    item[position] = !item[position];
}

const onUpdate = (item, index) => {
    currentIndex.value = -1;
    props.note.selectedNotes.splice(index, 1, editValue.value)
}

const teetPosition = () => {
    return {
        first: false,
        second: false,
        third: false,
        fourth: false
    }
}

const onInsertOrUpdateCcNote = (type, index = -1) => {
    if (type === 'add') {
        markedPosition.value.push(teetPosition());
    }

    if (type === 'delete') {
        markedPosition.value.splice(index, 1);
    }
}

watch(() => markedPosition.value, (newVal) => {
    if (isInitialMount.value) return;
    props.note.markedPositions = newVal;
}, { deep: true })


onMounted(() => {
    isInitialMount.value = true;
    for (let i = 0; i < props.note.selectedNotes.length; i++) {
        if(props.note.markedPositions[i]){
            markedPosition.value.push(props.note.markedPositions[i]);
        }else{
            markedPosition.value.push(teetPosition());
        }
    }
    isInitialMount.value = false;
});

defineExpose({
    onInsertOrUpdateCcNote
})

</script>

<style scoped>
.first-col {
    border-bottom: 1px solid gray;
    border-right: 1px solid gray;
    min-height: 20px;
    cursor: pointer;
}
.second-col {
    border-bottom: 1px solid gray;
    min-height: 20px;
    cursor: pointer;
}
.third-col {
    border-right: 1px solid gray;
    min-height: 20px;
    cursor: pointer;
}
.fourth-col {
    min-height: 20px;
    cursor: pointer;
}
.note-title {
    min-width: 200px;
}
.group-template {
    width: 180%;
    margin-left: -50%;
}
.no-dots {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.note-input{
    position: absolute;
    width: 60%;
    padding: 0.271rem 1rem;
    display: inherit;
    top: -5px;
    left: 3%;
}
.note-input-investigation-history{
    position: absolute;
    width: 43%;
    padding: 0.271rem 1rem;
    display: inherit;
    top: -5px;
    left: 52%;
}
.note-body .card-body{
    padding: 0 2%;
}
.note-head {
    display: flex;
    margin-top: 2%;
    justify-content: space-between;
    margin-bottom: 1%;
}
.action .close {
    color: red;
    cursor: pointer;
}
.note-body .card {
    background: #f9f9f9;
    min-height: 100px;
    margin-bottom: 1rem;
}
.medicine {
    margin: 3% 0 6% 0;
    position: relative;
}
.medicine:last-child {
    margin-bottom: 3%;
}
</style>